import { defineAsyncComponent } from 'vue'
export default {
  "standalone-snowplow-layout": defineAsyncComponent(() => import("/codebuild/output/src2719559069/src/layouts/StandaloneSnowplowLayout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/codebuild/output/src2719559069/src/layouts/default.vue").then(m => m.default || m))
}